import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CustomHeader = () => {
  const { currentUser, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-gray-800 text-white shadow-md">
      <div className="container mx-auto px-4 py-4">
        {/* Desktop and Mobile Layout */}
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold">Metrics Explorer</Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center">
            <ul className="flex space-x-8">
              <li><Link to="/" className="hover:text-blue-300 py-2">Home</Link></li>
              <li><Link to="/stats" className="hover:text-blue-300 py-2">Stats</Link></li>
              <li><Link to="/health" className="hover:text-blue-300 py-2">Health</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-300 py-2">Pricing</Link></li>
            </ul>
          </nav>
          
          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {currentUser ? (
              <>
                <Link to="/profile" className="hover:text-blue-300">Profile</Link>
                <button 
                  onClick={logout} 
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link 
                  to="/login" 
                  className="hover:text-blue-300"
                >
                  Login
                </Link>
                <Link 
                  to="/register" 
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                  Register
                </Link>
              </>
            )}
          </div>
          
          {/* Hamburger Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={toggleMenu}
              className="p-2 focus:outline-none"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-2">
            <nav className="flex flex-col space-y-3">
              <Link to="/" className="hover:text-blue-300 py-2 px-1" onClick={toggleMenu}>Home</Link>
              <Link to="/stats" className="hover:text-blue-300 py-2 px-1" onClick={toggleMenu}>Stats</Link>
              <Link to="/health" className="hover:text-blue-300 py-2 px-1" onClick={toggleMenu}>Health</Link>
              <Link to="/pricing" className="hover:text-blue-300 py-2 px-1" onClick={toggleMenu}>Pricing</Link>
            </nav>
            
            <div className="mt-4 pt-4 border-t border-gray-700 flex flex-col space-y-3">
              {currentUser ? (
                <>
                  <Link to="/profile" className="hover:text-blue-300 py-2 px-1" onClick={toggleMenu}>Profile</Link>
                  <button 
                    onClick={() => {
                      logout();
                      toggleMenu();
                    }} 
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-left"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link 
                    to="/login" 
                    className="hover:text-blue-300 py-2 px-1"
                    onClick={toggleMenu}
                  >
                    Login
                  </Link>
                  <Link 
                    to="/register" 
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                    onClick={toggleMenu}
                  >
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default CustomHeader;
